import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  username: null,
  profile: null,
};

const userProfileSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUserProfileData: (state, action) => {
      state.profile = action.payload;
      state.username = `${action?.payload?.first_name ?? ''} ${action?.payload?.last_name ?? ''}`;
    },
    clearUser: state => {
      state.profile = null;
      state.username = null;
    },
  },
});

export const { setUserProfileData, clearUser } = userProfileSlice.actions;
export const userProfile = userProfileSlice.reducer;
